import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { loginWithGoogle, getGoogleLoginObject } from '../plugins/google/login';

import { pushOrRedirect, isEmbedded } from '../commons/query';
import { getStepAfterLogin } from './entrar-action';
import { sendSuccessfulyMessage, sendFailMessage } from '../commons/utils/post-message';
import GoogleIcon from '../icons/google-icon';

class GoogleButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      loading: false,
      googleObject: null
    };
  }

  componentDidMount() {
    this.initializeGoogle();
  }

  render() {
    return (
      <div className="googleLogin">
        {this.state.googleObject && this.renderGoogleButton()}
        {this.state.loading && <div className="loading" />}
        {this.state.error && (
          <p onAnimationEnd={this.cleanErrors} className="googleLogin-error">
            {this.state.error}
          </p>
        )}
      </div>
    );
  }

  renderGoogleButton = () => (
    <div
      ref={button => (this.googleLoginButton = button)}
      className="google-button-wrapper"
      onClick={this.onOpenGoogleAuthPopup}
    >
      <GoogleIcon />
      <div className="google-button-text">Continuar com o Google</div>
    </div>
  );

  cleanErrors = () => this.setState({ error: '' });

  displayErrorMessage = error => this.setState({ error });

  setLoading = status => this.setState({ loading: status });

  initializeGoogle = () => {
    getGoogleLoginObject()
      .then(auth2 => {
        this.setState({ googleObject: auth2 }, this.attachButtonClickHandler);
      })
      .catch(Promise.reject);
  };

  attachButtonClickHandler = () => {
    const loginButton = this.googleLoginButton;
    const success = this.successfulLoginHandler;
    const failure = this.failedLoginHandler;

    this.state.googleObject.attachClickHandler(loginButton, {}, success, failure);
  };

  successfulLoginHandler = googleUser => {
    const authenticationInfo = googleUser.getAuthResponse();
    loginWithGoogle(authenticationInfo)
      .then(getStepAfterLogin)
      .then(url => {
        if (isEmbedded()) {
          sendSuccessfulyMessage();
        } else {
          pushOrRedirect(this.props.history.push, url);
        }
      })
      .catch(error => {
        this.setLoading(false);
        this.displayErrorMessage('Não foi possível completar seu cadastro');
        sendFailMessage(error);
      });
  };

  failedLoginHandler = () => {
    this.setLoading(false);
    this.displayErrorMessage('Ocorreu um erro na sua autenticação');
  };

  onOpenGoogleAuthPopup = () => {
    this.cleanErrors();
    this.setLoading(true);
  };
}

export default withRouter(GoogleButton);
